import { initialState, State, Action } from 'store/store';

export const addScormResponse = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    userBehaviour: {
      ...state.userBehaviour,
      scormResponses: {
        ...state.userBehaviour.scormResponses,
        [data.id]: data,
      },
    },
  };
};
